var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.625C4.11719 0.625 3.29688 0.847656 2.53906 1.29297C1.80469 1.72266 1.22266 2.30469 0.792969 3.03906C0.347656 3.79688 0.125 4.61719 0.125 5.5C0.125 6.38281 0.347656 7.20312 0.792969 7.96094C1.22266 8.69531 1.80469 9.27734 2.53906 9.70703C3.29688 10.1523 4.11719 10.375 5 10.375C5.88281 10.375 6.70312 10.1523 7.46094 9.70703C8.19531 9.27734 8.77734 8.69531 9.20703 7.96094C9.65234 7.20312 9.875 6.38281 9.875 5.5C9.875 4.61719 9.65234 3.79688 9.20703 3.03906C8.77734 2.30469 8.19531 1.72266 7.46094 1.29297C6.70312 0.847656 5.88281 0.625 5 0.625ZM5 1.375C5.75 1.375 6.44531 1.5625 7.08594 1.9375C7.70312 2.30469 8.19531 2.79688 8.5625 3.41406C8.9375 4.05469 9.125 4.75 9.125 5.5C9.125 6.25 8.9375 6.94531 8.5625 7.58594C8.19531 8.20312 7.70312 8.69531 7.08594 9.0625C6.44531 9.4375 5.75 9.625 5 9.625C4.25 9.625 3.55469 9.4375 2.91406 9.0625C2.29688 8.69531 1.80469 8.20312 1.4375 7.58594C1.0625 6.94531 0.875 6.25 0.875 5.5C0.875 4.75 1.0625 4.05469 1.4375 3.41406C1.80469 2.79688 2.29688 2.30469 2.91406 1.9375C3.55469 1.5625 4.25 1.375 5 1.375ZM4.625 3.25V5.125H2.75V5.875H4.625V7.75H5.375V5.875H7.25V5.125H5.375V3.25H4.625Z",
    fill: "#089BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIconSmall);
export default __webpack_public_path__ + "static/media/add-icon-small.91dc90721e2bbb3de7d66be5a7e9ce3e.svg";
export { ForwardRef as ReactComponent };